import { render } from "./ChallengeParticipants.vue?vue&type=template&id=15fd5aba"
import script from "./ChallengeParticipants.vue?vue&type=script&lang=js"
export * from "./ChallengeParticipants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__